<div class="modal-primary" *transloco="let t">
  <div class="w-[50rem]">
    @if (asinnumber) {
      <div class="row mx-2">
        <div class="card col-12">
          @if (marketplace) {
            <app-product-view [asin]="asinnumber" [marketplace]="marketplace"></app-product-view>
          }
        </div>
      </div>
    }
    <div class="strategies-list flex flex-col gap-2 p-2">
      @for (strategy of activeStrategies; track strategy) {
        <div class="rounded border p-2">
          <div>
            @if (strategy.strategyId) {
              <app-strategy-link [strategyId]="strategy.strategyId" [withCampaignType]="true" class="w-full" />
            }
          </div>
        </div>
      } @empty {
        <div class="mb-2 flex justify-center">{{ t("product-details.no_startegy") }}</div>
      }
    </div>
  </div>
</div>
